import { render, staticRenderFns } from "./ChatMessageToast.vue?vue&type=template&id=607faa92&"
import script from "./ChatMessageToast.vue?vue&type=script&lang=js&"
export * from "./ChatMessageToast.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessageToast.vue?vue&type=style&index=0&id=607faa92&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports